<template>
  <StatusChangeProcedureApplyInput label="复学"
                                   class="status-change-procedure-apply-reenter"
                                   v-on="$listeners"
                                   :resolve-form="getApplyInfo">
    <template>
      <slot></slot>
    </template>
    <template #form>
      <el-form size="mini"
               label-width="140px"
               label-suffix="：">
        <el-form-item label="复学班级">
          <ClazzPicker v-model="form.targetClassId"></ClazzPicker>
        </el-form-item>
        <el-form-item v-if="form.targetClassId">
          <StudentCourseDockPanel ref="dock"
                                  :student-id="studentId"
                                  :clazz-id="form.targetClassId"></StudentCourseDockPanel>
        </el-form-item>
        <el-form-item label="办理复学时交纳费用">
          <div class="input-group">
            <el-input-number v-model="form.reenterFee"
                             controls-position="right"
                             :min="0"
                             :precision="2"
                             :step="1"></el-input-number>
            <span class="unit">元</span>
          </div>
        </el-form-item>
      </el-form>
    </template>
  </StatusChangeProcedureApplyInput>
</template>

<script>
import StatusChangeProcedureApplyInput from '../input'
import ClazzPicker from '../../../../../../../../biz/picker/clazz'
import StudentCourseDockPanel from '../../../../../wrapper/panel/student/course/dock'
import objectUtils from '../../../../../../../../../util/objectUtils'
export default {
  name: 'StatusChangeProcedureApplyReenter',
  components: {
    StatusChangeProcedureApplyInput,
    ClazzPicker,
    StudentCourseDockPanel
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      form: {
        targetClassId: '',
        reenterFee: undefined
      }
    }
  },
  methods: {
    getApplyInfo () {
      return new Promise((resolve, reject) => {
        if (!this.form.targetClassId) {
          reject(new Error('请选择复学班级'))
          return
        }
        if (!objectUtils.hasValue(this.form.reenterFee)) {
          reject(new Error('请填写办理复学时交纳费用'))
          return
        }
        this.handleApply(this.form, resolve, reject)
      })
    },
    handleApply (form, resolve, reject) {
      this.$nextTick(() => {
        const dock = this.$refs.dock
        const promise = dock ? dock.getDockInfo() : Promise.resolve()
        promise.then(result => {
          resolve({
            url: '/workspace/manager/status/change/procedure/reenter/submitApply',
            data: this.$qs.stringify(this.$extend({
              postId: this.studentId
            }, form, this.extraParams, result))
          })
        }).catch(err => reject(err))
      })
    }
  },
  watch: {
    visible (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          if (typeof this.form[key] === 'string') {
            this.form[key] = val[key] || ''
          } else {
            this.form[key] = val[key]
          }
        })
      }
    }
  }
}
</script>
